//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CincinattiStrokeScale',
  data () {
    return {
      defaultJson: {
        'Abnormal: Slurred or inappropriate words or mute': '异常：口齿含糊或不正确用词或缄默。',
        'Normal': '正常',
        'Abnormal: One side of face does not move as well as the other (or at all)': '异常：一侧面部活动不如对侧（或根本无法活动）。',
        'Facial droop': '面部下垂',
        'Normal: Both arms move equally or not at all': '正常：双臂活动对称或根本不动。',
        'Arm drift': '上肢滑落',
        'Normal: Both sides of face move equally': '正常：双侧面部活动对称。',
        "Have the person say: 'You can't teach an old dog new tricks' or some other simple, familiar saying.": '嘱患者重复：“对牛弹琴”或其他简单的俗语。',
        'Speech': '言语',
        'Have the person close his or her eyes and hold his or her arms straight out in front for about 10 seconds.': '嘱患者闭眼并向前伸直双臂保持 10 秒。',
        'Abnormal: One arm does not move, or one arm drifts down compared with the other side': '异常：一侧上肢无法活动，或较对侧向下滑落。',
        'Normal: Patient uses correct words with no slurring': '正常：患者用词恰当发音清晰。',
        'Abnormal': '异常',
        'Stroke likely': '脑卒中可能',
        'Have the person smile or show his or her teeth.': '嘱患者笑或露出牙齿。'
      },
      form: {
        trachealSecretions: '',
        infiltratesCXR: '',
        temperature: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', shortName: '正常', name: '正常:双侧面部活动对称。'},
        {value: '1', shortName: '异常', name: '异常:一侧面部活动不如对侧（或根本无法活动）。'}
      ],
      dataList2: [
        {value: '0', shortName: '正常', name: '正常:双臂活动对称或根本不动。'},
        {value: '1', shortName: '异常', name: '异常:一侧上肢无法活动，或较对侧向下滑落。'}
      ],
      dataList3: [
        {value: '0', shortName: '正常', name: '正常:患者用词恰当发音清晰。'},
        {value: '1', shortName: '异常', name: '异常:口齿含糊或不正确用词或缄默。'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
          	// trachealSecretions + infiltratesCXR + temperature + wcc + paO2FiO2 + (progressionInfiltrate ? progressionInfiltrate : 0) + (culture ? culture : 0)
        let result = form.trachealSecretions + form.infiltratesCXR + form.temperature
        if (+result > 0) {
          self.hasScore = true
        } else {
          self.hasScore = false
        }
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/CincinattiStrokeScale.vue